import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AttendedMSME, EnrolledMSME, GradingEvent, GradingFeedback, IAGrading } from '../../../../../shared/models/IAProposal';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
interface Feedback {
  Id: number;
  IntervensionId: number;
  ComponentId: number;
  EventId: string;
  Feedback: string; // JSON string for the feedback answers
  Status: number;
  IndustryAssociationId: number;
  Score: number;
  IAUserId: number;
  CreatedDate: string;
  CreatedBy: number;
}


@Component({
  selector: 'app-grading',
  templateUrl: './grading.component.html',
  styleUrl: './grading.component.css'
})


export class GradingComponent implements OnInit {
  @ViewChild('colMd12', { static: false }) colMd12!: ElementRef;

  dynamicHtml: SafeHtml | undefined;
  private loadDataSubscription: Subscription = new Subscription();
  private loadSubscription: Subscription = new Subscription();
  private loadEventSubscription: Subscription = new Subscription();
  private loadEnrolledSubscription: Subscription = new Subscription();
  private loadAttendedSubscription: Subscription = new Subscription();
  private loadFeedbackSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();


  userType = sessionStorage.getItem('UserType');
  dataSource!: MatTableDataSource<IAGrading>
  displayedColumns: string[] = ['rowNum', 'nameOfOrganisation', 'iaUserName', 'totalEventCount', 'createdBy', 'starRating']

  dataSourceGradingEvent!: MatTableDataSource<GradingEvent>
  displayedEventColumns: string[] = ['Sr.No', 'eventId', 'eventName', 'totalEnrolledMSME', 'totalAttendedMSME']

  dataSourceEnrolled!: MatTableDataSource<EnrolledMSME>
  displayedEnrolledColumns: string[] = ['Sr.No', 'eventId', 'udyamNumber', 'nameOfEnterprise','participantName', 'status']

  dataSourceAttended!: MatTableDataSource<AttendedMSME>
  displayedAttendedColumns: string[] = ['Sr.No', 'eventId', 'udyamRegistrationNumber', 'registrationType', 'enterpriseName', 'participantName']

  dataSourceGradingFeedback!: MatTableDataSource<GradingFeedback>
  displayedFeedbackColumns: string[] = ['Sr.No', 'eventId', 'eventName', 'udyamNumber','enrollmentId', 'enterpriseName', 'feedback'] //, 'participantName', 'feedback'


  private dialogRef!: MatDialogRef<any>;
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatPaginator) paginationEvent!: MatPaginator;
  @ViewChild(MatPaginator) paginationEnrolled!: MatPaginator;
  @ViewChild(MatPaginator) paginationAttended!: MatPaginator;
  @ViewChild(MatPaginator) paginationFeedback!: MatPaginator;

  @ViewChild(MatSort) sort!: MatSort;

  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';


  data: any[] = []; // Declare data as a class property

  frmGrading: FormGroup;
  Intervention_help: any[] = [];
  Component_help: any = [];
  LoadGrading: any[] = [];
  GradingReportFile: File | null = null;
  allrecord: any[] = [];

  //dataSource: any[] = []; // Your full data source
  totalItems: number = 0; // Example total items

  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  length: number = 0;
  pageSize: number = 10;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  constructor(private sanitizer: DomSanitizer, private dialog: MatDialog, private formBuilder: FormBuilder, private apiService: ApiService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private commonService: CommonService, private toastrService: ToastrService) {
    this.frmGrading = this.formBuilder.group({
      intervention: ['', [Validators.required]],
      interest: ['', [Validators.required]]
    });

  }
  DtoPagination = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "InterventionId": "",
    "InterestId": "",
  }

  DtoPaginationEvent = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "ImplementationAgencyId": "",
    "InterventionId": "",
    "InterestId": "",
  }

  DtoPaginationEnrolled = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "uniqueEventId": "",
  }

  DtoPaginationAttended = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "uniqueEventId": "",
  }

  DtoPaginationFeedback = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "ImplementationAgencyId": "",
    "InterventionId": "",
    "InterestId": ""
  }

  ngOnInit(): void {
    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SortColumn = "";
    this.DtoPagination.SortDirection = "";
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.InterestId = "";
    this.DtoPagination.InterventionId = "";

    this.DtoPaginationEvent.PageNumber = 1;
    this.DtoPaginationEvent.PageSize = 10;
    this.DtoPaginationEvent.SortColumn = "";
    this.DtoPaginationEvent.SortDirection = "";
    this.DtoPaginationEvent.SearchTerm = "";
    this.DtoPaginationEvent.ImplementationAgencyId = "";

    this.DtoPaginationEnrolled.PageNumber = 1;
    this.DtoPaginationEnrolled.PageSize = 10;
    this.DtoPaginationEnrolled.SortColumn = "";
    this.DtoPaginationEnrolled.SortDirection = "";
    this.DtoPaginationEnrolled.SearchTerm = "";
    this.DtoPaginationEnrolled.uniqueEventId = "";

    this.DtoPaginationAttended.PageNumber = 1;
    this.DtoPaginationAttended.PageSize = 10;
    this.DtoPaginationAttended.SortColumn = "";
    this.DtoPaginationAttended.SortDirection = "";
    this.DtoPaginationAttended.SearchTerm = "";
    this.DtoPaginationAttended.uniqueEventId = "";

    this.getintervention_help();
    this.LoadGradingRecord();    
  }

  ngAfterViewInit() {
    if (!this?.sort) {
      console.error("MatSort is not initialized!");
      return;
    }
    this.LoadGradingRecord();    
  }

  resetPage() {
    this.frmGrading.reset();
    this.LoadGradingRecord();
  }

  LoadGradingRecord() {
    const intervention = this.frmGrading.get('intervention')?.value ?? "";
    const interest = this.frmGrading.get('interest')?.value ?? "";

    this.loadDataSubscription.unsubscribe();

    if (!this?.sort) {
      //console.error("Error: MatSort is undefined");
      return;
    }
    this.sort?.sortChange.subscribe(() => this.pagination.pageIndex = 0);

    this.loadDataSubscription = merge(
      this.sort?.sortChange,
      this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort?.active;
          this.DtoPagination.SortDirection = this.sort?.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;
          this.DtoPagination.InterventionId = intervention;
          this.DtoPagination.InterestId = interest;
          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETGRADING, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp.status) {
            this.length = resp.totalRecords;
          }
          return resp.data;
        })
      ).subscribe(data => {
        this.dataSource = data;
        this.allrecord = data;
        this.adjustPaginator();
      });

  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.loadSubscription.unsubscribe();
    this.loadEventSubscription.unsubscribe();
    this.loadEnrolledSubscription.unsubscribe();
    this.loadAttendedSubscription.unsubscribe();
    this.loadFeedbackSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  getintervention_help() {
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETINTERVENTION).subscribe({
      next: (response: any) => {
        this.Intervention_help = response.status ? response.data : (this.toastrService.error('Error fetching Component data', 'Oops...'), null);
      },
      error: (error: any) => {
        this.toastrService.error('Error fetching intervention data', 'Oops...');
      }
    });
  }

  GetComponent(e: any) {
    const Interventionid = e.value;
    var getComponent = {
      Interventionid: Interventionid
    }

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETINTEREST, getComponent).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.Component_help = response.data;
        } else {
          this.toastrService.error('Error fetching Component data', 'Oops...');
        }
      },
      error: (error: any) => {
        this.Component_help = null;
        this.toastrService.error('Error fetching Component data1', 'Oops...');
      }
    });
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadGradingRecord();
  }


  //#region My exportToPDF
  exportToPDF(): void {
    // Initialize jsPDF in landscape mode
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    // Define table columns
    const columns = [
      'Sr. No',
      'Email',
      'Name',
      'Latest Event Date',
      'Event Count	',
      'MSME Feedback Count	',
      'Star Rating'
    ];

    // Prepare table rows
    const rows = this.allrecord.map((item, index) => [
      item.rowNum, // Sr. No
      item.iaUserName,
      item.nameOfOrganisation,    
      item.latestEventDate,
      item.totalEventCount,
      item.createdBy,
      item.starRating
    ]);

    // Add a title to the PDF
    doc.text('Grading Report List', 14, 15);

    // Generate the table using autoTable
    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 25, // Start the table below the title
      theme: 'striped',
      headStyles: { fillColor: [22, 160, 133] },
      styles: { fontSize: 6, cellWidth: 'auto' },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 20 },
      columnStyles: {
        0: { cellWidth: 10 }, // Sr. No
        1: { cellWidth: 20 }, // nameoOfOrganisation
        2: { cellWidth: 20 }, // iaUserName
        3: { cellWidth: 20 }, // interventionName
        4: { cellWidth: 30 }, // interestName
        5: { cellWidth: 20 }, // latestEventDate
        6: { cellWidth: 15 }, // totalEventCount
        7: { cellWidth: 45 }, // msmeFeedbackCount
        8: { cellWidth: 45 }, // starRating      
      },
    });

    // Save the PDF file
    doc.save('Grading_Report_List.pdf');
  }
  //#endregion

  //#region My exportToExcel
  exportToExcel(): void {
    // Define the file name
    const fileName = 'Grading_Report_List.xlsx';
    // Prepare the data for export
    const excelData = this.allrecord.map((item, index) => ({
      'Sr.No': item.rowNum,
      'Email': item.iaUserName, 
      'Name': item.nameOfOrganisation,   
      'latest Event Date': item.latestEventDate,
      'Total Event Count': item.totalEventCount,
      'MSME Feedback Count': item.createdBy,
      'Star Rating': item.starRating,
    }));

    // Create a worksheet from the data
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Grading Report List': worksheet },
      SheetNames: ['Grading Report List'],
    };

    // Generate a buffer for the Excel file
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    // Save the Excel file
    this.saveExcelFile(excelBuffer, fileName);
  }
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }
  //#endregion


  //rating = 2.5; // Set the rating value here
  stars = new Array(5); // Array for 5 stars

  // Function to determine the star icon type (full, half, or empty)
  getStarType(index: number, rating: any): 'full' | 'half' | 'empty' {
    const roundedRating = Math.round(rating * 2) / 2; // Round to nearest half
    const isFull = index < Math.floor(roundedRating);
    const isHalf = index < roundedRating && index >= Math.floor(roundedRating);
    return isFull ? 'full' : isHalf ? 'half' : 'empty';
  }

  onSearchClick(searchValue: string): void {
    this.sort.active = 'starRating';
    this.sort.direction = 'desc';
    const intervention = this.frmGrading.get('intervention')?.value ?? "";
    const interest = this.frmGrading.get('interest')?.value ?? "";
    if (intervention != '' && interest != ''){
      this.LoadGradingRecord();
    }    
  }



  //#region My Event Section
  eventPageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  eventLength: number = 0;
  eventPageSize: number = 10;
  eventDisplayedData: any[] = [];
  eventHidePageSize = false;
  eventShowPageSizeOptions = true;
  eventShowFirstLastButtons = true;
  eventDisabled = false;
  eventPageIndex = 0;
  eventPageEvent!: PageEvent;

  onPageEventChange(e: PageEvent) {
    this.pageEvent = e;
    this.eventLength = e.length;
    this.eventPageSize = e.pageSize;
    this.eventPageIndex = e.pageIndex;

    this.DtoPaginationEvent.PageNumber = e.pageIndex + 1;
    this.DtoPaginationEvent.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETEVENTLIST, this.DtoPaginationEvent)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.dataSourceGradingEvent = resp.data;
          this.eventLength = resp.totalRecords;
        }
      });
  }

  onViewEvent(templateRef: TemplateRef<any>, industryAssociationId: string): void {
    const intervention = this.frmGrading.get('intervention')?.value ?? "";
    const interest = this.frmGrading.get('interest')?.value ?? "";


    if (!this.paginationEvent) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadEventSubscription.unsubscribe();
    // Reset subscription with a new request
    this.loadEventSubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.paginationEvent.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.paginationEvent.pageIndex = 0;
          this.DtoPaginationEvent.SortColumn = this.sort?.active;
          this.DtoPaginationEvent.SortDirection = this.sort?.direction;
          this.DtoPaginationEvent.SearchCol = this.commonService.searchText;
          this.DtoPaginationEvent.ImplementationAgencyId = industryAssociationId;
          this.DtoPaginationEvent.InterventionId = intervention;
          this.DtoPaginationEvent.InterestId = interest;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETEVENTLIST, this.DtoPaginationEvent)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            const dialogRef1 = this.dialog.open(templateRef, {
              width: '1200vw',
              height: '80vh'
            });
            dialogRef1.afterClosed().subscribe(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll for UX
              this.notCallingPopup();
            });
            this.eventLength = resp.totalRecords;
            return resp?.data || {};
          }
        })        
      )
      .subscribe(data => {
        this.dataSourceGradingEvent = data;
        this.adjustEventPaginator();
      });

  }
  adjustEventPaginator() {
    const totalPages = Math.ceil(this.eventLength / this.eventPageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.eventPageIndex >= totalPages) {
      this.eventPageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationEvent.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.paginationEvent.pageIndex = this.eventPageIndex;
  }
  //#endregion

  //#region My Enrolled Section
  enrolledPageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  enrolledLength: number = 0;
  enrolledPageSize: number = 10;
  enrolledDisplayedData: any[] = [];
  enrolledHidePageSize = false;
  enrolledShowPageSizeOptions = true;
  enrolledShowFirstLastButtons = true;
  enrolledDisabled = false;
  enrolledPageIndex = 0;
  enrolledPageEvent!: PageEvent;


  onPageEnrolledChange(e: PageEvent) {
    this.enrolledPageEvent = e;
    this.enrolledLength = e.length;
    this.enrolledPageSize = e.pageSize;
    this.enrolledPageIndex = e.pageIndex;

    this.DtoPaginationEnrolled.PageNumber = e.pageIndex + 1;
    this.DtoPaginationEnrolled.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETENROLLEDMSMELISTFORMSSIDC, this.DtoPaginationEnrolled)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.dataSourceEnrolled = resp.data;
          this.enrolledLength = resp.totalRecords;
        }
      });
  }

  onViewEnrolled(templateRef1: TemplateRef<any>, uniqueEventId: string): void {
   if (!this.paginationEnrolled) return;

   // Unsubscribe from previous subscription to prevent multiple API calls
   if (this.loadEnrolledSubscription) {
     this.loadEnrolledSubscription.unsubscribe();
   }

   // Scroll to the top immediately when function is triggered
   window.scrollTo({ top: 0, behavior: 'smooth' });

   // Reset subscription with a new request
   this.loadEnrolledSubscription = merge(
     this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
     this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
     this.paginationEnrolled.page.pipe(takeUntil(this.destroy$))
   )
     .pipe(
       filter(searchTerm => searchTerm != null),
       switchMap(() => {
         this.paginationEnrolled.pageIndex = 0;
         this.DtoPaginationEnrolled.SortColumn = this.sort?.active;
         this.DtoPaginationEnrolled.SortDirection = this.sort?.direction;
         this.DtoPaginationEnrolled.SearchCol = this.commonService.searchText;
         this.DtoPaginationEnrolled.uniqueEventId = uniqueEventId;

         return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETENROLLEDMSMELISTFORMSSIDC, this.DtoPaginationEnrolled)
           .pipe(catchError(() => of(null)));
       }),
       map(resp => {
         if (resp && resp.status) {
           this.enrolledLength = resp.totalRecords;
           return resp?.data || {};
         }
         return null;
       })
     )
     .subscribe(data => {
       if (data) {
         this.dataSourceEnrolled = data;
         this.adjustEnrolledPaginator();
         // Scroll to the top again to ensure proper placement after data load
         window.scrollTo({ top: 0, behavior: 'smooth' });
         this.notCallingPopup();
       }
       
       // Open dialog after grid data is updated
       const dialogRef2 = this.dialog.open(templateRef1, {
         width: '1100px', // Customize the width of the dialog
         height: '60vh', // Optionally customize the height
       });

       dialogRef2.afterClosed().subscribe(() => {
         window.scrollTo({ top: 0, behavior: 'smooth' });
       });
     });
}


  adjustEnrolledPaginator() {
    const totalPages = Math.ceil(this.enrolledLength / this.enrolledPageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.enrolledPageIndex >= totalPages) {
      this.enrolledPageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationEnrolled.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.paginationEnrolled.pageIndex = this.enrolledPageIndex;
  }
  //#endregion

  //#region My Attended Section
  attendedPageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  attendedLength: number = 0;
  attendedPageSize: number = 10;
  attendedDisplayedData: any[] = [];
  attendedHidePageSize = false;
  attendedShowPageSizeOptions = true;
  attendedShowFirstLastButtons = true;
  attendedDisabled = false;
  attendedPageIndex = 0;
  attendedPageEvent!: PageEvent;


  onPageAttendedChange(e: PageEvent) {
    this.attendedPageEvent = e;
    this.attendedLength = e.length;
    this.attendedPageSize = e.pageSize;
    this.attendedPageIndex = e.pageIndex;

    this.DtoPaginationAttended.PageNumber = e.pageIndex + 1;
    this.DtoPaginationAttended.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETATTENDEDMSMELISTFORMSSIDC, this.DtoPaginationAttended)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.dataSourceAttended = resp.data;
          this.enrolledLength = resp.totalRecords;
        }
      });
  }
  onViewAttended(templateRef2: TemplateRef<any>, uniqueEventId: string): void {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadAttendedSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadAttendedSubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPaginationAttended.SortColumn = this.sort?.active;
          this.DtoPaginationAttended.SortDirection = this.sort?.direction;
          this.DtoPaginationAttended.SearchCol = this.commonService.searchText;
          this.DtoPaginationAttended.uniqueEventId = uniqueEventId;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETATTENDEDMSMELISTFORMSSIDC, this.DtoPaginationAttended)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            const dialogRef3 = this.dialog.open(templateRef2, {
              width: '1100px', // Customize the width of the dialog
              height: '60vh', // Optionally customize the height
            });
            dialogRef3.afterClosed().subscribe(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.notCallingPopup();
            });
            this.attendedLength = resp.totalRecords;
            return resp?.data || {};
          }
        })
      )
      .subscribe(data => { 
        this.dataSourceAttended = data;
        this.adjustAttendedPaginator();
      });
  }

  adjustAttendedPaginator() {
    const totalPages = Math.ceil(this.attendedLength / this.attendedPageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.attendedPageIndex >= totalPages) {
      this.attendedPageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationAttended.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.paginationAttended.pageIndex = this.attendedPageIndex;
  }

  //#endregion

  //#region My Feedback Section
  feedbackPageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  feedbackLength: number = 0;
  feedbackPageSize: number = 10;
  feedbackDisplayedData: any[] = [];
  feedbackHidePageSize = false;
  feedbackShowPageSizeOptions = true;
  feedbackShowFirstLastButtons = true;
  feedbackDisabled = false;
  feedbackPageIndex = 0;
  feedbackPageEvent!: PageEvent;


  onPageFeedbackChange(e: PageEvent) {
    this.feedbackPageEvent = e;
    this.feedbackLength = e.length;
    this.feedbackPageSize = e.pageSize;
    this.feedbackPageIndex = e.pageIndex;

    this.DtoPaginationFeedback.PageNumber = e.pageIndex + 1;
    this.DtoPaginationFeedback.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETFEEDBACKLIST, this.DtoPaginationFeedback)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
         
          this.dataSourceGradingFeedback = resp.data;
          this.feedbackLength = resp.totalRecords;
        }
      });
  }
  
  onViewFeedback(templateRef3: TemplateRef<any>, industryAssociationId: string): void {
    if (!this.pagination) return;

    const intervention = this.frmGrading.get('intervention')?.value ?? "";
    const interest = this.frmGrading.get('interest')?.value ?? "";

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadFeedbackSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadFeedbackSubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPaginationFeedback.SortColumn = this.sort?.active;
          this.DtoPaginationFeedback.SortDirection = this.sort?.direction;
          this.DtoPaginationFeedback.SearchCol = this.commonService.searchText;
          this.DtoPaginationFeedback.ImplementationAgencyId = industryAssociationId;
          this.DtoPaginationFeedback.InterventionId = intervention
          this.DtoPaginationFeedback.InterestId = interest

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETFEEDBACKLIST, this.DtoPaginationFeedback)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            const dialogRef4 = this.dialogRef =  this.dialog.open(templateRef3, {
              width: '1200px', // Customize the width of the dialog
              height: '80vh', // Optionally customize the height
            });
            dialogRef4.afterClosed().subscribe(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.notCallingPopup();
            });
            this.feedbackLength = resp.totalRecords;
            
            return resp?.data || {};
          }
        })
      )
      .subscribe(data => {
        this.dataSourceGradingFeedback = data;
        console.log(data);
        this.adjustFeedbackPaginator();
      });
  }

  adjustFeedbackPaginator() {
    const totalPages = Math.ceil(this.feedbackLength / this.feedbackPageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.feedbackPageIndex >= totalPages) {
      this.feedbackPageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationFeedback.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.paginationFeedback.pageIndex = this.feedbackPageIndex;
  }
  //#endregion

  onClosePopup() {
    this.DtoPaginationEvent.PageNumber = 1;
    this.eventPageIndex = 0;  // Reset event page index
    this.paginationEvent.pageIndex = 0;  // Reset pagination event index    

    this.DtoPaginationEnrolled.PageNumber = 1;
    this.enrolledPageIndex = 0;
    this.paginationEnrolled.pageIndex = 0;    

    this.DtoPaginationAttended.PageNumber = 1;
    this.attendedPageIndex = 0;
    this.paginationAttended.pageIndex = 0;

    this.DtoPaginationFeedback.PageNumber = 1;
    this.feedbackPageIndex = 0;
    this.paginationFeedback.pageIndex = 0; 
  }

  action(uniqueEventId: string): void {
    this.router.navigate(['/reports/viewevent', uniqueEventId]);
    this.closeDialog();
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  SubmitFeedback(eventId: string, msMeUserName: string, uniqueEventId: string, enrollmentId: string) {
    if (this.userType == 'MSSIDC') {
      sessionStorage.setItem("EventId", eventId);
      sessionStorage.setItem("UniqueEventId", uniqueEventId);
      sessionStorage.setItem("EnrollmentId", enrollmentId);
      sessionStorage.setItem('msMeUserName', msMeUserName);
      this.router.navigate(['/feedbackmssidc']);
    }
    this.closeDialog();
  }

  notCallingPopup() {
    this.loadDataSubscription.unsubscribe();
    this.loadSubscription.unsubscribe();
    this.loadEventSubscription.unsubscribe();
    this.loadEnrolledSubscription.unsubscribe();
    this.loadAttendedSubscription.unsubscribe();
    this.loadFeedbackSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.LoadGradingRecord();
  }
}
